<template>
  <div class="position-relative form-group w-100 d-flex align-items-center">
    <label class="m-0 font-weight-bold">Share this template</label>
    <div class="togglebox-container ml-2">
      <input type="checkbox" name="shared" :checked="meta.shared" @change.stop.prevent="store.commit('meta.shared', Number($event.target.checked))" />
      <div class="slider"></div>
    </div>
  </div>
  <div class="position-relative w-100 mt-3 d-flex flex-wrap">
    <div class="position-relative form-group col-12 p-0 mb-0 d-flex align-items-center">
      <label class="m-0 font-weight-bold">Upload</label>
      <div class="btn-upload d-inline-block ml-2">
        <label for="btn-upload-file" class="m-0 btn btn-outline-success">Choose</label>
        <input id="btn-upload-file" type="file" @input="inputFile" />
      </div>
    </div>
  </div>
  <hr />
  <div class="position-relative w-100 mt-3 d-flex flex-wrap">
    <ul class="template-fields w-100">
      <li class="template-item">
        <div class="row w-100 m-0">
          <div class="col-8 pl-0"><strong>Field</strong></div>
          <div class="col-4 pr-0"><strong>Label</strong></div>
        </div>
      </li>
      <li v-for="(row, index) in meta.data" :key="index" class="template-item">
        <div class="row w-100 m-0">
          <div class="flex-1 pl-0">
            <Select :options="fieldOptions" :taggable="true" placeholder="Field" data-title="Field" class="has-tip" :value="row.field" @changeValue="store.commit(`meta.data.${index}.field`, $event)"></Select>
          </div>
          <div class="col-4 pr-0">
            <input type="text" class="form-control" :value="row.title" @change="store.commit(`meta.data.${index}.title`, $event.currentTarget.value)" />
          </div>
          <button class="ml-3 btn-transition btn btn-outline-danger" @click.prevent="handleRemoveField(index)">Remove</button>
        </div>
      </li>
    </ul>
    <button class="mb-2 mr-2 btn-transition btn btn-outline-success" @click.prevent="handleAddField">Add Field</button>
  </div>
</template>

<script>
import Event from '@/helper/event.js'
import { read, utils } from 'xlsx'

export default {
  mixins: [Event],
  data() {
    return {
      defaultTemplate: {
        title: '',
        value: '',
        field: ''
      }
    }
  },
  computed: {
    storeId() {
      return this.config?.storeId
    },
    templateId() {
      return this.config?.templateId
    },
    data() {
      return this.store.getter('', {})
    },
    meta() {
      return this.data?.meta || {}
    },
    fieldOptions() {
      return this.data?.meta?.fields || []
    }
  },
  methods: {
    async inputFile(e) {
      let file = await e.target.files[0].arrayBuffer()
      let wb = read(file)
      let data = []
      utils
        .sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1 })
        .shift()
        .forEach((title) => {
          data.push(
            Object.assign({}, this.defaultTemplate, {
              title: title
            })
          )
        })
      e.target.value = null
      this.store.commit('meta.data', data)
    },
    handleAddField() {
      let data = Object.values(Object.assign({}, this.data.meta.data))
      data.push({})
      this.store.commit('meta.data', data)
    },
    handleRemoveField(index) {
      let data = Object.values(Object.assign({}, this.data.meta.data))
      data.splice(index, 1)
      this.store.commit('meta.data', data)
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.edit-template-form {
  .template-fields {
    list-style: none;
    padding: 0;
    .template-item {
      padding: 10px 0;
      border-bottom: 1px solid #dfdfdf;
    }
  }
}
</style>
